module.exports = __webpack_public_path__ + "static/media/google.be05d6df.svg";